(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // Advance-on-video-end autoplay for <slideshow-component autoplay-on-video-end="N">.
  //
  // The stock component only knows a fixed-interval timer (its `autoplay` attribute). In this mode
  // the section omits that attribute and this script drives `next()` instead: a slide holding a
  // video advances when that video fires `ended` (the slide block renders it with loop=false); a
  // slide without one, or whose video refuses to play, falls back to a timer of N seconds. Each
  // time a slide becomes current its video is rewound and replayed.
  (() => {
    const ATTRIBUTE = 'autoplay-on-video-end';
    const BOUND = 'data-video-end-bound';

    const setup = (slideshow) => {
      if (slideshow.hasAttribute(BOUND)) return;
      slideshow.setAttribute(BOUND, '');

      const fallbackSeconds = parseInt(slideshow.getAttribute(ATTRIBUTE), 10) || 4;
      let fallbackTimer;
      let activeSlide = slideshow.querySelector(
        ':scope > slideshow-container > slideshow-slides > slideshow-slide[aria-hidden="false"]'
      );

      const advance = () => {
        if (!document.hidden) slideshow.next();
      };

      const armFallback = () => {
        clearTimeout(fallbackTimer);
        fallbackTimer = setTimeout(advance, fallbackSeconds * 1000);
      };

      const arm = () => {
        clearTimeout(fallbackTimer);
        const video = activeSlide?.querySelector('video');
        if (!video) {
          armFallback();
          return;
        }
        video.loop = false;
        try {
          video.currentTime = 0;
        } catch (error) {
          // Media not ready yet; play() below still starts from the beginning.
        }
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(armFallback);
      };

      // `ended` does not bubble, so listen in the capture phase on the component.
      slideshow.addEventListener(
        'ended',
        (event) => {
          if (activeSlide?.contains(event.target)) advance();
        },
        true
      );

      slideshow.addEventListener('slideshow:select', (event) => {
        if (event.target !== slideshow) return;
        activeSlide = event.detail?.slide ?? activeSlide;
        arm();
      });

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && slideshow.isConnected) arm();
      });

      slideshow.querySelectorAll('video').forEach((video) => {
        video.loop = false;
      });
      arm();
    };

    const boot = () => document.querySelectorAll(`slideshow-component[${ATTRIBUTE}]`).forEach(setup);

    customElements.whenDefined('slideshow-component').then(boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
